import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import SigmaLogo from "src/assets/images/S1GMA_Logo.svg"
import { setCurrentSelectedTab } from "src/thunks/depotUsers";

function AdminHeader({ RightSidebarOpenCloseFlag }) {

    /** redux store useDispatch & useSelector ------------------------------ **/
    const dispatch = useDispatch();
    const { signoutModelOpenFlag } = useSelector((state) => state.auth);

    /** hooks useState ----------------------------------------------------- **/
    const [selectedValue, setSelectedValue] = useState("DEPOTS")


    /** Variable declarations ----------------------------------------------------- **/
    const bgClassName = selectedValue ? "background-color-set-for-selected-tab" : "";

    /** hooks useEffect----------------------------------------------------- **/

    // Execute when select any of the tab from admin and save selected tab value in redux.
    useEffect(() => {
        dispatch(setCurrentSelectedTab(selectedValue))
    }, [selectedValue])

    return (
        <>
            <div className={`d-flex  main-header-div ${signoutModelOpenFlag == true ? "add-overlay-for-depot-dropdown" : ""}`}>
                <div className="d-flex flex-row" style={{ flex: 1 }}>
                    <div className="d-flex align-items-center ms-2" style={{ flex: RightSidebarOpenCloseFlag ? "0.42" : "0.36" }}>
                        <img width={90} height={35} src={SigmaLogo} alt="muz image" />
                    </div>
                    <div className="d-flex flex-row " style={{ flex: 4 }}>
                        <div className={`${selectedValue == "DEPOTS" ? bgClassName : ""} d-flex align-items-center justify-content-center admin-menu-headers`} onClick={() => setSelectedValue("DEPOTS")}>
                            DEPOTS
                        </div>

                        <div className={`${selectedValue == "DEPOTS PERSONNEL" ? bgClassName : ""} d-flex align-items-center justify-content-center admin-menu-headers`} onClick={() => setSelectedValue("DEPOTS PERSONNEL")}>
                            DEPOTS PERSONNEL
                        </div>

                        <div className={`${selectedValue == "CLIENTS/PROJECTS" ? bgClassName : ""} d-flex align-items-center justify-content-center admin-menu-headers`} onClick={() => setSelectedValue("CLIENTS/PROJECTS")}>
                            CLIENTS/PROJECTS
                        </div>

                        <div className={`${selectedValue == "PROJECT MANAGERS" ? bgClassName : ""} d-flex align-items-center justify-content-center admin-menu-headers`} onClick={() => setSelectedValue("PROJECT MANAGERS")}>
                            PROJECT MANAGERS
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AdminHeader;
